export const validation = {
  maxTitleChar: 200,
  maxParagraphChar: 5000
}
